import { BaseContext } from '../basecontext';
import { HandleKnownFailures, HandleKnownFailuresImpl } from './handleknownfailures';

export interface ValidateKnownFailures
{
    handleUnAuthorised(): HandleKnownFailures;
    isTokenExpired(expiryTime: number): boolean;
    refreshToken(): HandleKnownFailures;
}

export class ValidateKnownFailuresImpl implements ValidateKnownFailures
{
    private handleKnowFailures: HandleKnownFailures;

    constructor(context: BaseContext) 
    {
        this.handleKnowFailures = new HandleKnownFailuresImpl(context);
    }

    isTokenExpired(expiryTime: number): boolean 
    {
       return (expiryTime - Date.now()) <= 0 ? true : false;
    }

    refreshToken(): HandleKnownFailures 
    {
      return this.handleKnowFailures.refreshToken();
    }

    handleUnAuthorised(): HandleKnownFailures 
    {
        return this.handleKnowFailures.handleUnAuthorised();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/handleknownfailures/validateknownfailures.ts